import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AvailableTabProperties } from '../../../../interface/device-management.interface';

import Alerts from './Alerts';
import ChargingSchedules from './ChargingSchedules';
import DeviceData from './DeviceData';
import GuestCharging from './GuestCharging';
import MaintenanceSchedule from './MaintenanceSchedule';
import OcppLogs from './OcppLogs';
import RfidCards from './RfidCards';
import Timeline from './Timeline';
import Transactions from './Transactions';

/**
 * Component to display device button tabs
 * @returns
 */
function DeviceDetailsBottomContainer() {
  const { t } = useTranslation('devices');
  const [deviceDetailsTabs, setDeviceDetailsTabs] = useState([
    {
      label: t('deviceData'),
      key: 'device-data',
      isActive: true,
    },
    {
      label: t('alerts'),
      key: 'alerts',
      isActive: false,
    },
    {
      label: t('transactions'),
      key: 'transactions',
      isActive: false,
    },
    {
      label: t('guestCharging'),
      key: 'guest-charging',
      isActive: false,
    },
    {
      label: t('upcomingMaintenanceSchedules'),
      key: 'upcoming-maintenance-schedules',
      isActive: false,
    },
    {
      label: t('upcomingChargingSchedules'),
      key: 'upcoming-charging-schedules',
      isActive: false,
    },
    {
      label: t('rfidCardsAssociated'),
      key: 'rfid-cards-associated',
      isActive: false,
    },
    {
      label: t('timeline'),
      key: 'timeline',
      isActive: false,
    },
    {
      label: t('oCPPLogs'),
      key: 'ocpp-logs',
      isActive: false,
    },
  ]);

  /**
   * Function to switch the tab
   * @param {string} key
   */
  const handleSwitchTab = (key: string) => {
    setDeviceDetailsTabs((previousTabs: AvailableTabProperties[]) =>
      previousTabs.map((tab) => {
        if (tab.key === key) {
          return {
            ...tab,
            isActive: true,
          };
        }
        return {
          ...tab,
          isActive: false,
        };
      }),
    );
  };

  return (
    <div className="device-details-bottom-wrap">
      <div className="device-details-bottom-tabs">
        {deviceDetailsTabs.map((tab) => (
          <div
            key={tab.key}
            className={`each-tab ${tab.isActive ? 'active' : ''}`}
            role="presentation"
            onClick={() => handleSwitchTab(tab.key)}>
            <h6>{tab.label}</h6>
            <div className="bottom-green" />
          </div>
        ))}
      </div>
      <div className="device-details-bottom-container">
        {(() => {
          const activeTab = deviceDetailsTabs.find((detail) => detail.isActive);
          let dataToShow = null;
          if (activeTab) {
            switch (activeTab.key) {
              case 'device-data':
                dataToShow = <DeviceData />;
                break;
              case 'alerts':
                dataToShow = <Alerts />;
                break;
              case 'transactions':
                dataToShow = <Transactions />;
                break;
              case 'guest-charging':
                dataToShow = <GuestCharging />;
                break;
              case 'upcoming-charging-schedules':
                dataToShow = <ChargingSchedules />;
                break;
              case 'rfid-cards-associated':
                dataToShow = <RfidCards />;
                break;
              case 'upcoming-maintenance-schedules':
                dataToShow = <MaintenanceSchedule />;
                break;
              case 'ocpp-logs':
                dataToShow = <OcppLogs />;
                break;
              case 'timeline':
                dataToShow = <Timeline />;
                break;
              default:
                dataToShow = null;
            }
          }
          return dataToShow;
        })()}
      </div>
    </div>
  );
}

export default DeviceDetailsBottomContainer;
